// extracted by mini-css-extract-plugin
export default {"flex-col":"PasswordFindResult_flex-col__18eQ+","text":"PasswordFindResult_text__uGGS+"};